import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import moment from 'moment/moment';
import { discountStatus } from '../../enum/discountStatus';
import { StyledBodyRow } from '../StyledBodyRow';
import { StyledBodyCell } from '../StyledBodyCell';

export const getDiscountStatusName = (status) => {
    switch (status) {
        case discountStatus.assigned: return <Typography color="success" sx={{fontSize: 12}}>Assigned</Typography>;
        case discountStatus.frozen: return <Typography color="info" sx={{fontSize: 12}}>Frozen</Typography>;
        case discountStatus.burned: return <Typography color="error" sx={{fontSize: 12}}>Burned</Typography>;
    }
}

export const DiscountTableRow = ({discount, onDiscountSelect, isSelected, onFreeze, onBurn, onThaw, loading}) => {
    const formatDate = (date) => moment(date).format('DD/MM/YYYY');
    const getDiscountStatusName = (status) => {
        switch (status) {
            case discountStatus.assigned: return <Typography color="success" sx={{fontSize: 12}}>Assigned</Typography>;
            case discountStatus.frozen: return <Typography color="info" sx={{fontSize: 12}}>Frozen</Typography>;
            case discountStatus.burned: return <Typography color="error" sx={{fontSize: 12}}>Burned</Typography>;
        }
    }

    return <StyledBodyRow
        onClick={() => {onDiscountSelect(discount)}}
        selected={isSelected}
    >
        <StyledBodyCell>{discount.owner.name}</StyledBodyCell>
        <StyledBodyCell>{getDiscountStatusName(discount.status)}</StyledBodyCell>
        <StyledBodyCell>{discount.discount_condition.patient_type.name}</StyledBodyCell>
        <StyledBodyCell>{discount.discount_condition.country.name}</StyledBodyCell>
        <StyledBodyCell>{discount.discount_condition.category.name}</StyledBodyCell>
        <StyledBodyCell>{discount.discount_condition.amount}%</StyledBodyCell>
        <StyledBodyCell>{formatDate(discount.created)}</StyledBodyCell>
        <StyledBodyCell>{formatDate(discount.discount_condition.expires)}</StyledBodyCell>
        <StyledBodyCell>
            {discount.status === discountStatus.assigned &&
                <Button
                    disabled={loading}

                    variant="contained"
                    color="info"
                    onClick={() => onFreeze(discount)}
                >
                    Freeze
                </Button>}
            {discount.status === discountStatus.frozen &&
                <Button
                    disabled={loading}
                    variant="contained"
                    color="error"
                    onClick={() => onBurn(discount)}
                    sx={{marginRight: 1}}
                >
                    Burn
                </Button>}
            {discount.status === discountStatus.frozen &&
                <Button
                    disabled={loading}
                    variant="contained"
                    color="success"
                    onClick={() => onThaw(discount)}
                >
                    Thaw
                </Button>
            }
        </StyledBodyCell>
    </StyledBodyRow>;
}
